import { useDatasourcesStore } from "@/stores/datasources";
import { defineNuxtPlugin } from "nuxt/app";

export default defineNuxtPlugin(async () => {
  const store = useDatasourcesStore();
  await store.fetchEntries();
  await store.fetchTagEntries();
  await store.fetchSettings();
});
